import { render, staticRenderFns } from "./ApprovalList.vue?vue&type=template&id=d136ab34"
import script from "./ApprovalList.vue?vue&type=script&lang=js"
export * from "./ApprovalList.vue?vue&type=script&lang=js"
import style0 from "./ApprovalList.vue?vue&type=style&index=0&id=d136ab34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports